import findSharingPermissionByEmail from '../utils/findSharingPermissionByEmail';
import getSharingPermissionListToSearch from '../utils/getSharingPermissionListToSearch';
import getStore from '../store/sharingStore';
import SharingPermissionItemState from '../store/schema/SharingPermissionItemState';
import {
    isDelegate,
    getCalendarSharingPermissionsDropdownTooltip,
} from '../utils/CalendarSharingPermissionsUtils';
import { mutator } from 'satcheljs';
import { removeSharingPermissionFromArray } from './removeCalendarSharingPermissionMutator';
import { updateCalendarSharingPermissionInStore } from '../actions/calendarSharing';
import calendarStrings from 'owa-strings/owa-calendar-strings';
import { format } from 'owa-strings';

export default mutator(updateCalendarSharingPermissionInStore, msg => {
    let viewState = getStore().viewState;
    let sharingPermissionItem = msg.sharingPermission;

    if (!viewState || !sharingPermissionItem) {
        return;
    }

    let filteredPermissions: SharingPermissionItemState[] = findSharingPermissionByEmail(
        getSharingPermissionListToSearch(sharingPermissionItem, viewState),
        sharingPermissionItem
    );

    // When a non-delegate is made a delegate, the older permission item is in peopleInsideOrg
    if (filteredPermissions.length == 0) {
        filteredPermissions = findSharingPermissionByEmail(
            viewState.peopleInsideOrg,
            sharingPermissionItem
        );
    }

    if (filteredPermissions && filteredPermissions.length) {
        // When a non-delegate is made a delegate, remove the corresponding entry
        // from peopleInsideOrg and add it to the delegates section
        if (!isDelegate(filteredPermissions[0]) && isDelegate(sharingPermissionItem)) {
            removeSharingPermissionFromArray(viewState.peopleInsideOrg, filteredPermissions[0]);
            viewState.delegates.push(sharingPermissionItem);
        } else {
            filteredPermissions[0].CurrentDetailLevel = sharingPermissionItem.CurrentDetailLevel;
            filteredPermissions[0].ViewPrivateAppointments =
                sharingPermissionItem.ViewPrivateAppointments;
        }
    }

    viewState.userActionAriaLabel = format(
        calendarStrings.updatePermissionSuccessAriaLabel,
        sharingPermissionItem.EmailAddress.Name,
        getCalendarSharingPermissionsDropdownTooltip(sharingPermissionItem.CurrentDetailLevel)
    );
});
